import React, { useCallback, useEffect, useMemo, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import Select from "react-select";
import { useApproveSGBPSApplicationByFinalApproverMutation, useCostAlloctionBySGBPProducatInformationIdMutation, useLazyGetCertificateGroupingDetailsByIdQuery, useLazyGetProductDetailsListByProductInformationIdQuery, useUpdateApplicationStatusOnPeerReviewerReturnMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import ModalGroupingTable from "./components/ModalGroupingTable";
import CostAllocation from "./components/CostAllocation";
import ToastService from "../../services/toastService/ToastService";
import { useLazyGetPeerReviewEvaluationDetailsByIdQuery, useReturnApplicationToCaseOfficerByPeerReviewerMutation } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import SwalAlert from "../../services/swalService/SwalService";

const CertificateGroupingListApprove = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [productList, setProductList] = useState([]);
  const [costAllocationList, setCostAllocationList] = useState([]);
  const [approver, setApprover] = useState();
  const [peerReviewer, setPeerReviewer] = useState();
  const [peerReviewerComment, setPeerReviewerComment] = useState("")
  const [approverReviewerComment, setApproverReviewerComment] = useState("")
  const { success, error, confirm } = SwalAlert();
  const [getProductDetailsListByProductInformationId, { isLoading: productListLoading, isSuccess: productListSuccess, data: productListData }] = useLazyGetProductDetailsListByProductInformationIdQuery();
  const [getCertificateGroupingDetailsById, { isLoading: certificateGroupingDetailsLoading, isSuccess: certificateGroupingDetailsSuccess, data: certificateGroupingDetailsData }] = useLazyGetCertificateGroupingDetailsByIdQuery();
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [saveCertificateGrouping, { isLoading: saveCertificateGroupingLoading, isSuccess: saveCertificateGroupingSuccess, data: saveCertificateGroupingData }] = useCostAlloctionBySGBPProducatInformationIdMutation();
  const [approveSGBPSApplicationByFinalApprover, { isLoading: approveApplicationLoading, isSuccess: approveApplicationSuccess, data: approveApplicationData }] = useApproveSGBPSApplicationByFinalApproverMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [returnToCaseOfficer, { isLoading: returnToCaseOfficeLoading, isSuccess: returnToCaseOfficerSuccess, data: returnToCaseOfficerData, },] = useReturnApplicationToCaseOfficerByPeerReviewerMutation();
  const [updateApplicationStatusOnPeerReviewerReturn, { isLoading: updateStatusOnReturnLoading, isSuccess: updateStatusOnReturnLoadingSuccess, data: updateStatusOnReturnLoadingData }] = useUpdateApplicationStatusOnPeerReviewerReturnMutation();


  const approverOptionsMemo = useMemo(() => productsAndServicesDropDownsData?.filter((item) => item.dropdownName === "Approver List")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData, certificateGroupingDetailsData]);

  const itemCodeOptionsMemo = useMemo(() => productsAndServicesDropDownsData
    ?.filter((item) => item.dropdownName === "Items Codes")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData, certificateGroupingDetailsData]
  );

  const handleSendToFinalApprover = () => {
    // let req = { SGBPProductInformationId: decryptAESID(id), }
    let req = { SGBPProductInformationId: decryptAESID(id), FinalApproverComment: approverReviewerComment }

    if (req) {
      approveSGBPSApplicationByFinalApprover(req);
    }
  };

  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      productsAndServicesDropdown();
      getProductDetailsListByProductInformationId(editID);
      getCertificateGroupingDetailsById(editID);
      getPeerReviewEvaluationDetailsById(editID)
    }
  }, [id]);

  useEffect(() => {
    if (!productListLoading && productListSuccess && productListData) {
      setProductList(productListData);
    }
  }, [productListLoading, productListSuccess, productListData]);

  useEffect(() => {
    if (!certificateGroupingDetailsLoading && certificateGroupingDetailsSuccess && certificateGroupingDetailsData) {
      let data = certificateGroupingDetailsData?.allocationCostList.map((item) => ({
        label: item?.certificateNumber,
        value: item?.itemCode,
        id: item?.sgbpCertificateGroupingId
      }))
      setCostAllocationList(data);
      const peerReviewerOption = approverOptionsMemo?.find((item) => item.value === certificateGroupingDetailsData?.peerReviewerId);
      const approverOption = approverOptionsMemo?.find((item) => item.value === certificateGroupingDetailsData?.approverId);
      setPeerReviewer(peerReviewerOption || null);
      setApprover(approverOption || null);
    }
  }, [certificateGroupingDetailsLoading, certificateGroupingDetailsSuccess, certificateGroupingDetailsData, productsAndServicesDropDownsData]);

  useEffect(() => {
    if (!saveCertificateGroupingLoading && saveCertificateGroupingData && saveCertificateGroupingSuccess) {
      ToastService.success("Certificate Data Save Successfully!");
    }
  }, [saveCertificateGroupingLoading, saveCertificateGroupingData, saveCertificateGroupingSuccess]);

  useEffect(() => {
    if (!returnToCaseOfficeLoading && returnToCaseOfficerSuccess && returnToCaseOfficerData) {
      if (!returnToCaseOfficerData.hasError) {
        ToastService.success("Application Returned to Case Officer");
        handleBack();
      } else {
        ToastService.error(returnToCaseOfficerData.errorMessage);
      }
    }
  }, [returnToCaseOfficeLoading, returnToCaseOfficerSuccess, returnToCaseOfficerData]);

  useEffect(() => {
    if (!approveApplicationLoading && approveApplicationSuccess && approveApplicationData) {
      ToastService.success("Application has been approved successfully");
      navigate("/viewApplicationTaskList");
    }
  }, [approveApplicationLoading, approveApplicationSuccess, approveApplicationData]);

  useEffect(() => {
    if (!getPeerReviewEvaluationDetailsByIdLoading && getPeerReviewEvaluationDetailsByIdSuccess && getPeerReviewEvaluationDetailsByIdData) {
      setPeerReviewerComment(getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment)
      setApproverReviewerComment(getPeerReviewEvaluationDetailsByIdData?.finalApproverComment)
    }
  }, [getPeerReviewEvaluationDetailsByIdLoading, getPeerReviewEvaluationDetailsByIdSuccess, getPeerReviewEvaluationDetailsByIdData]);

  const handleCombine = () => {
    setShowAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
  };

  const handleBack = () => {
    navigate("/viewApplicationTaskList");
  };

  const handleSave = useCallback(() => {
    const applicationId = decryptAESID(id?.toString(), false);
    const req = {
      comments: certificateGroupingDetailsData?.commentFromCaseOfficer,
      peerReviewerId: peerReviewer?.value,
      approverId: approver?.value,
      sGBPSApplicationId: applicationId,

      costAllocationRequestListRequest: costAllocationList.map((row) => {
        if (row.value == null) return;
        const [certificateNumber, certPrefix] = row.label.split("/");
        const prefix = Number(certPrefix);
        return {
          itemCode: row.value,
          certificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
          // certPrefix: certPrefix ? Number(certPrefix) : null,
          certPrefix: certPrefix === undefined || prefix === 0 ? null : prefix,
          sGBPSApplicationId: applicationId,
          sgbpCertificateGroupingId: row?.id ?? 0,
        };
      }).filter(Boolean),

      modelGroupingRequestListRequest: productList.map(
        ({ textValue, rating, certPrefix, sgbpProductId, applicationNumber }) => ({
          sgbpProductId,
          textValue,
          rating: Number(rating),
          // certPrefix: Number(certPrefix),
          certPrefix: Number(certPrefix) === 0 ? null : Number(certPrefix),
          certificateNumber: String(applicationNumber),
        })
      ),
    };
    saveCertificateGrouping(req);
  }, [id, peerReviewer, approver, costAllocationList, productList, saveCertificateGrouping]);


  const handleReturnApplication = () => {
    let req = {}
    req.sGBPProductInformationId = decryptAESID(id);
    req.peerReviewerComment = peerReviewerComment
    req.FinalApproverComment = approverReviewerComment
    if (req) {
      // handleSave();
      returnToCaseOfficer(req)
      updateApplicationStatusOnPeerReviewerReturn({ SGBPProductInformationId: decryptAESID(id) });
    }
  };


  const handleApprovalChange = (e) => {
    setApproverReviewerComment(e.target.value);
  }

  const handleReturn = () => {
    confirm('Return?', 'Are you sure you want to return?', 'Return', 'Cancel').then((confirmed) => {
      if (confirmed) {
        handleReturnApplication();
      }
    });
  };

  const buildCostAllocationRows = (list, itemCodes, existingRows = []) => {
    const uniqueMap = new Map();
    list.forEach((item) => {
      const certNumber = item.applicationNumber;
      const certPrefix = item.certPrefix;
      const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, true);
      }
    });

    return Array.from(uniqueMap.keys()).map((label, index) => {
      const existingExact = existingRows?.find((row) => row.label === label);
      const existingByIndex = existingRows?.[index];

      return {
        id: index + 1,
        label,
        options: itemCodes,
        value: existingExact ? existingExact.value : null, // <-- cleared when label changes
        sgbpCertificateGroupingId: existingExact?.sgbpCertificateGroupingId ?? existingByIndex?.sgbpCertificateGroupingId ?? 0,
        // finalCertificateAndCostAllocationId: existingExact?.finalCertificateAndCostAllocationId ?? existingByIndex?.finalCertificateAndCostAllocationId ?? 0,
      };
    });
  };





  return (
    <div className="certificate-grouping-list-page">
      <div className="crud-requirement-list">
        <div className="corporate-member-list">
          <ModalGroupingTable
            data={productList}
          />
          <CostAllocation
            rows={costAllocationList}
            options={itemCodeOptionsMemo}
          />
          <div className="table-title mt-5 mb-4">
            <h3>Internal Notes</h3>
          </div>
          <div className="mt-2">
            <label className="form-label">Comments from Case Officer</label>
            <textarea disabled
              className="form-control mt-1"
              rows="4"
              value={certificateGroupingDetailsData?.commentFromCaseOfficer}
            ></textarea>
          </div>
          <div className="mt-2">
            <label>Peer Reviewer Comment</label>
            <textarea
              disabled
              className="form-control mt-1"
              rows="4"
              value={peerReviewerComment}
              maxLength={200}
            />
          </div>
          <div className="mt-2">
            <label>Approver Reviewer Comment</label>
            <textarea
              // disabled
              className="form-control mt-1"
              rows="4"
              value={approverReviewerComment}
              onChange={handleApprovalChange}
              maxLength={200}
            />
          </div>
          <div className="table-title mt-5 mb-4">
            <h3>Assign to</h3>
          </div>
          <div className="dropdown-select-wrapper">
            <div className="d-flex align-items-center mb-4">
              <label className="form-label mb-0 w-20">Peer Reviewer</label>
              <Select
                className="custom-checkbox-select"
                value={peerReviewer}
                options={approverOptionsMemo}
                isDisabled={true}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="form-label mb-0 w-20">Approver</label>
              <Select
                className="custom-checkbox-select"
                value={approver}
                options={approverOptionsMemo}
                isDisabled={true}
              />

            </div>
          </div>
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
              onClick={handleBack}
            />
            <div className="d-flex gap-3">
              <Buttons
                buttonText="Return"
                buttonTypeClassName="reject btn"
                onClick={handleReturn}
                isLoading={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
                isDisable={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
              />
              <Buttons
                buttonText="Approve"
                buttonTypeClassName="success-btn"
                onClick={handleSendToFinalApprover}
                isLoading={approveApplicationLoading}
                isDisable={approveApplicationLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateGroupingListApprove;
